import React, { useContext } from 'react';
import { B as Banner } from './Banner-hHc_G3rw.js';
import { selectCategory } from './storeSelectors/category.js';
import { selectProduct } from './storeSelectors/product.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import { C as CurrencyCode } from './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-qls1wwl1.js';
import useGetPageClass from './hooks/useGetPageClass.js';
import 'next/router';
import 'notistack';
import 'next-i18next';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { selectCurrentCurrencyCode } from './storeSelectors/currencies.js';

const BannerWrapper = ({ promotion }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!(promotion === null || promotion === void 0 ? void 0 : promotion.promo_is_active) || Number(promotion.promo_days_left) < 0)
        return null;
    const { promo_days_left: promoDaysLeftStr, promo_is_active: promoIsActive, promo_type: promoType, promo_end: promoEnd, } = promotion;
    const promoDaysLeft = Number(promoDaysLeftStr);
    const { useSelector } = useContext(CoreContext);
    const domain = process.env.NEXT_PUBLIC_SITE_URL;
    const isDevelopment = process.env.NODE_ENV === 'development' ||
        (domain === null || domain === void 0 ? void 0 : domain.includes('localhost')) ||
        (domain === null || domain === void 0 ? void 0 : domain.includes('dev-eu')) ||
        (domain === null || domain === void 0 ? void 0 : domain.includes('staging-eu'));
    const category = useSelector(selectCategory);
    const product = useSelector(selectProduct);
    const currencyCode = (_a = useSelector(selectCurrentCurrencyCode)) !== null && _a !== void 0 ? _a : CurrencyCode.EUR;
    const categoryName = ((_b = category === null || category === void 0 ? void 0 : category.category) === null || _b === void 0 ? void 0 : _b.name) || ((_c = product === null || product === void 0 ? void 0 : product.categories.slice(-1)[0]) === null || _c === void 0 ? void 0 : _c.name);
    const categoryNameEn = ((_d = category === null || category === void 0 ? void 0 : category.category) === null || _d === void 0 ? void 0 : _d.name_en.category_name) ||
        ((_e = product === null || product === void 0 ? void 0 : product.categories.slice(-1)[0]) === null || _e === void 0 ? void 0 : _e.name_en.category_name);
    const productNameEn = (_f = product === null || product === void 0 ? void 0 : product.name_en) === null || _f === void 0 ? void 0 : _f.product_name;
    const grammar = ((_h = (_g = category === null || category === void 0 ? void 0 : category.category) === null || _g === void 0 ? void 0 : _g.promo_banners) === null || _h === void 0 ? void 0 : _h.promo_grammar_rules) ||
        ((_j = product === null || product === void 0 ? void 0 : product.promo_banners) === null || _j === void 0 ? void 0 : _j.promo_grammar_rules);
    const replacementName = ((_l = (_k = category === null || category === void 0 ? void 0 : category.category) === null || _k === void 0 ? void 0 : _k.promo_banners) === null || _l === void 0 ? void 0 : _l.promo_category_replacement_name) ||
        (product === null || product === void 0 ? void 0 : product.promo_banners.promo_category_replacement_name);
    const pageClass = useGetPageClass();
    const isCheckout = pageClass === 'checkout';
    const disableBanner = promotion.employeeSite;
    const shouldShowBanner = promoIsActive && !isCheckout && !disableBanner;
    const endDate = new Date(promoEnd);
    const endDay = endDate.toLocaleDateString('en-US', { weekday: 'long' });
    const formatClass = (name) => name
        .replace(/ /g, '-')
        .toLowerCase()
        .replace(/&/g, 'and')
        // eslint-disable-next-line no-irregular-whitespace
        .replace(/​/g, '')
        .replace(/%/g, '')
        .replace(/'/g, '');
    // .replace(//g, ''); is due to the BO returning some ZeroWidthSpaces in the string, which breaks class selection in css.
    return (shouldShowBanner && (React.createElement("div", { role: "complementary", "data-event-name": "bloc_interact", "data-bloc-name": "promo banner" },
        React.createElement(Banner, { daysLeft: promoDaysLeft, ends: endDay, promoType: promoType, currencyCode: currencyCode, ...(categoryName && { categoryName }), ...(categoryNameEn && { categoryNameEn: formatClass(categoryNameEn) }), ...(productNameEn && { productNameEn: formatClass(productNameEn) }), ...(grammar && { grammar }), ...(replacementName && { replacementName }) }),
        isDevelopment &&
            [2, 1, 0].map(i => (React.createElement(Banner, { key: i, daysLeft: i, ends: endDay, promoType: promoType, currencyCode: currencyCode, ...(categoryName && { categoryName }), ...(categoryNameEn && { categoryNameEn: formatClass(categoryNameEn) }), ...(productNameEn && { productNameEn: formatClass(productNameEn) }), ...(grammar && { grammar }), ...(replacementName && { replacementName }) }))))));
};

export { BannerWrapper as B };
//# sourceMappingURL=BannerWrapper-WkrxNSmi.js.map
